export default "__VITE_ASSET__DOnbHSDA__"